import { AccountingPeriodStatusValues } from '../types/accounting-periods.types.js';
import { checkDateOverlap } from './date.utils.js';
export function checkPeriodsOverlap(period, existingPeriods, excludeId) {
    return existingPeriods.some((existing) => {
        if (excludeId !== undefined && existing.id === excludeId) {
            return false;
        }
        return checkDateOverlap(period.startDate, period.endDate, existing.startDate, existing.endDate);
    });
}
const statusDisplayNames = {
    [AccountingPeriodStatusValues.current]: 'En cours',
    [AccountingPeriodStatusValues.temporarilyClosed]: 'En clôture provisoire',
    [AccountingPeriodStatusValues.closed]: 'Clôturé',
};
export function getStatusDisplayName(status) {
    return statusDisplayNames[status];
}
const statusColors = {
    [AccountingPeriodStatusValues.current]: 'green',
    [AccountingPeriodStatusValues.temporarilyClosed]: 'orange',
    [AccountingPeriodStatusValues.closed]: 'red',
};
export function getStatusColor(status) {
    return statusColors[status];
}
export const CLOSED_PERIOD_ERROR = 'Cette période est clôturée définitivement, modification impossible';
export function isDateInPeriods(periods, date) {
    const time = new Date(date).getTime();
    return periods.some((period) => time >= new Date(period.startDate).getTime() && time <= new Date(period.endDate).getTime());
}
